import type { IFilters } from "../../interfaces/Components/ITable";

export type PersonAuditFilterKey =
  | "noUserId"
  | "noLegacyId"
  | "noAop"
  | "noRoleOrUsername";

export type PersonAuditScanType =
  | "b2cOrphans"
  | "duplicateFirmEmail"
  | "duplicateIdentity";

export const PERSON_AUDIT_ENDPOINT = "/person";

export function personAuditEndpoint(auditFilter: PersonAuditFilterKey): string {
  return `${PERSON_AUDIT_ENDPOINT}?auditFilter=${auditFilter}`;
}

/** Merged into API filter; backend strips and applies SQL audit condition. */
export function getAuditPersistentFilter(
  auditFilter: PersonAuditFilterKey,
): Record<string, IFilters> {
  return {
    __auditFilter: { value: auditFilter },
  };
}

/** Rolling last 7 days in Unix seconds for Cosmos `_ts` BETWEEN_TS. */
export function getLast7DaysTsRange(): string {
  const end = Math.floor(Date.now() / 1000);
  const start = end - 7 * 24 * 60 * 60;
  return `${start} - ${end}`;
}

export function getModifiedLastWeekPersistentFilter(): Record<string, IFilters> {
  return {
    _ts: {
      value: [getLast7DaysTsRange()],
      comparisonType: "BETWEEN_TS",
    },
  };
}

export interface PersonAuditRow {
  id: string;
  generatedId?: number;
  name?: string;
  lastName?: string;
  firm?: string;
  firmName?: string;
  firmEmail?: string;
  userId?: string;
  legacyId?: string;
  role?: string;
  userName?: string;
  duplicateGroup?: string;
  groupCount?: number;
  _ts?: number;
}
